module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "MAIN_PAGE",
    attrs: {
      "id": "d5e2199"
    }
  }, [_c('p', {
    staticClass: "h4",
    attrs: {
      "id": "d41156131"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chap2_thegunse_9781569478004_epub_part2#d4115401",
      "id": "d9t001-0"
    }
  }, [_c('b', [_vm._v("Two ")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx25",
    attrs: {
      "id": "d41156161"
    }
  }, [_c('i', [_vm._v("For a long time I used to go to bed early.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx25",
    attrs: {
      "id": "d41156162"
    }
  }, [_vm._v("MARCEL PROUST ")]), _vm._v(" "), _c('p', {
    staticClass: "tx15",
    attrs: {
      "id": "d41156211"
    }
  }, [_vm._v("I arrived back at the flat and went through the usual answerphone routine. Two meaningless bleeps, one wrong number, one call from a friend interrupted in the first sentence, followed by three people I didn't want to hear from who I now had to ring back.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41156231"
    }
  }, [_vm._v("God, I hated that machine.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41156251"
    }
  }, [_vm._v("I sat down at my desk and went through the day's mail. I threw some bills into the bin, and then remembered that I'd moved the bin into the kitchen — so I got annoyed, stuffed the rest of the post into a drawer, and gave up on the idea that doing chores would help me to get things straight in my mind.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41156271"
    }
  }, [_vm._v("It was too late to start playing loud music, and the only other entertainment I could find in the flat was whisky, so I picked up a glass and a bottle of The Famous Grouse, poured myself a couple of fingers, and went into the kitchen. I added enough water to turn it into just a Vaguely Familiar Grouse, and then sat down at the table with a pocket dictaphone, because someone had once told me that talking out loud helps  clarify things. I'd said would it work with butter? and they'd said no, but it would work with whatever is troubling your spirit.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41156291"
    }
  }, [_vm._v("I put a tape in the machine and flicked the record switch.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41156311"
    }
  }, [_c('i', [_vm._v("'Dramatis personae,' ")]), _vm._v("I said. 'Alexander Woolf, father of Sarah Woolf, owner of dinky Georgian house in Lyall Street, Belgravia, employer of blind and vindictive interior designers, and Chairman and Chief Executive Officer of Gaine Parker. Unknown male Caucasian, American or Canadian, fiftyish. Rayner. Large, violent, hospitalised. Thomas Lang, thirty-six, Flat D, 42 Westbourne Close, late of the Scots Guards, honourable discharge with rank of Captain. The facts, insofar as they are known, are these.'\n         ")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41156401"
    }
  }, [_vm._v("I don't know why tape recorders make me talk like this, but they do.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41156421"
    }
  }, [_vm._v("'Unknown male attempts to secure employment of T. Lang for the purpose of committing unlawful killing of A. Woolf. Lang declines position on grounds of being nice. Principled. Decent. A gentleman.'")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41156481"
    }
  }, [_vm._v("I took a mouthful of whisky and looked at the dictaphone, wondering if I was ever going to play this soliloquy back to anyone. An accountant had told me it was a sensible thing to buy because I could get the tax back on it. But as I didn't pay any tax, have any need for a dictaphone, or trust the accountant as far as I could spit him, I looked upon this machine as one of my less sensible purchases.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41156501"
    }
  }, [_vm._v("Heigh ho.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41156521"
    }
  }, [_vm._v("'Lang goes to Woolf's house, with the intention of warning him against possible assassination attempt. Woolf absent. Lang decides to instigate enquiries.'")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41156561"
    }
  }, [_vm._v("I paused for a while, and the while turned into a long while, so I sipped some more whisky and laid aside the dictaphone while I did some thinking.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41156581"
    }
  }, [_vm._v("The only enquiry I had instigated had been the word 'what' - and I'd barely managed to get that out of my mouth before Rayner had hit me with a chair. Beyond that, all I'd done was half-kill a man and leave, wishing, pretty fervently, that I'd  other-half-killed him too. And you don't really want that sort of thing lying around on magnetic tape unless you know what you're doing. Which, amazingly enough, I didn't.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41156601"
    }
  }, [_vm._v("However, I'd just about known enough to recognise Rayner, even before I knew his name. I couldn't say he'd been following me exactly, but I've a good memory for faces -which makes up for being utterly pathetic with names - and Rayner's was not a difficult face. Heathrow airport, the public bar of some Devonshire Arms on the King's Road, and the entrance to Leicester Square tube had been enough of an advertisement, even for an idiot like me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41156631"
    }
  }, [_vm._v("I'd had the feeling that we were going to meet eventually, so I'd prepared myself for the rainy day by visiting Blitz Electronics on the Tottenham Court Road, where I'd shelled out two pounds eighty for a foot of large-diameter electrical cable. Flexible, heavy, and, when it comes to beating off brigands and footpads, better than any purpose-built cosh. The only time it doesn't work as a weapon is when you leave it in the kitchen drawer, still in its wrapping. Then it's really not very effective at all.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41156671"
    }
  }, [_vm._v("As for the unknown male Caucasian who'd offered me a killing job, well, I didn't hold out much hope of ever tracing him. Two weeks ago I'd been in Amsterdam, escorting a Manchester bookmaker who desperately wanted to believe that he had violent enemies. He'd hired me to bolster the fantasy. So I'd held car doors open for him, and checked buildings for snipers that I knew weren't there, and then spent a gruelling forty-eight hours sitting with him in night-clubs, watching him throw money in every direction but mine. When he'd finally wilted, I'd ended up loafing about my hotel room watching blue movies on television. The phone had rung - during a particularly good bit, as I remember - and a male voice had asked me to the bar for a drink.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41156711"
    }
  }, [_vm._v("I'd checked to make sure that the bookmaker was safely tucked up in bed with a nice warm prostitute, then sidled downstairs in the hope of saving myself forty quid by wringing a couple of drinks out of some old army friend.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41156731"
    }
  }, [_vm._v("But, as it turned out, the voice on the phone belonged to a short fat body in an expensive suit who I definitely didn't know. And didn't particularly want to know either, until he reached into his jacket and pulled out a roll of bank notes about as thick as I am.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41156751"
    }
  }, [_vm._v("American bank notes. Exchangeable for goods and services at literally thousands of retail outlets worldwide. He pushed a one hundred dollar bill across the table to me, so I spent five seconds quite liking the little chap, and then, almost immediately, love died.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41156771"
    }
  }, [_vm._v("He gave me some 'background' on a man named Woolf -where he lived, what he did, why he did it, how much he did it for - and then he told me that the bank note on the table had a thousand little friends, who would find their way into my possession if Woolf's life could be discreetly brought to an end.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41156791"
    }
  }, [_vm._v("I had to wait until our part of the bar was empty, which I knew wouldn't take long. At the prices they were charging for liquor, there were probably only a couple of dozen people in the world who could afford to stick around for a second drink.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41156811"
    }
  }, [_vm._v("When the bar had cleared, I leant across to the fat man and gave him a speech. It was a dull speech, but even so, he listened very carefully, because I'd reached under the table and taken hold of his scrotum. I told him what kind of a man I was, what kind of a mistake he'd made, and what he could wipe with his money. And then we'd parted company.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41156831"
    }
  }, [_vm._v("That was it. That was all I knew, and my arm was hurting. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx16",
    attrs: {
      "id": "d41156861"
    }
  }, [_vm._v("I went to bed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx21",
    attrs: {
      "id": "d41156881"
    }
  }, [_vm._v("I dreamt a lot of things that I won't embarrass you with, and ended up imagining that I was having to hoover my carpet. I kept hoovering and hoovering, but whatever was making the mark on the carpet just wouldn't go away.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41156901"
    }
  }, [_vm._v("Then I realised that I was awake, and that the stain on the carpet was sunlight because someone had just yanked open the curtains. In the twinkling of an eye I whipped my body  into a coiled, taut, come-and-get-it crouch, the electrical cable in my fist and bloody murder in my heart.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41156921"
    }
  }, [_vm._v("But then I realised that I'd dreamt that too, and what I was actually doing was lying in bed watching a large, hairy hand very close to my face. The hand disappeared, leaving a mug with steam coming out of it, and the smell of a popular infusion, sold commercially as PG Tips. Perhaps in that twinkling of an eye I'd worked out that intruders who want to slit your throat don't boil the kettle and open the curtains.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41156941"
    }
  }, [_vm._v("'Time is it?'")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41156961"
    }
  }, [_vm._v("'Thirty-five minutes past the hour of eight. Time for your Shreddies, Mr Bond.'")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41156981"
    }
  }, [_vm._v("I pulled myself up from the bed and looked over at Solomon. He was as short and cheerful as ever, with the same ghastly brown raincoat that he'd bought from the back pages of the "), _c('i', [_vm._v("Sunday Express.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41157021"
    }
  }, [_vm._v("'I take it you've come to investigate a theft?' I said, rubbing my eyes until white dots of light started appearing.")]), _vm._v(" "), _c('p', {
    staticClass: "tx8",
    attrs: {
      "id": "d41157041"
    }
  }, [_vm._v("'What theft would that be, sir?'")]), _vm._v(" "), _c('p', {
    staticClass: "tx8",
    attrs: {
      "id": "d41157061"
    }
  }, [_vm._v("Solomon called everyone 'sir' except his superiors.")]), _vm._v(" "), _c('p', {
    staticClass: "tx8",
    attrs: {
      "id": "d41157081"
    }
  }, [_vm._v("'The theft of my doorbell,' I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41157111"
    }
  }, [_vm._v("'If you are, in your sarcastic fashion, referring to my silent entrance to these premises, then may I remind you that I am a practitioner of the black arts. And practitioners, in order to qualify for the term, have to practise. Now be a good lad and jump into some kit will you? We're running late.'")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41157131"
    }
  }, [_vm._v("He disappeared into the kitchen and I could hear the clicking and buzzing of my fourteenth-century toaster.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41157151"
    }
  }, [_vm._v("I hauled myself out of bed, wincing as my left arm took some weight, slung on a shirt and a pair of trousers and took the electric razor into the kitchen.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41157171"
    }
  }, [_vm._v("Solomon had laid a place for me at the kitchen table, and set out some toast in a rack that I didn't even know I had. Unless he'd brought it with him, which seemed unlikely.")]), _vm._v(" "), _c('p', {
    staticClass: "tx8",
    attrs: {
      "id": "d41157211"
    }
  }, [_vm._v("'More tea, vicar?'")]), _vm._v(" "), _c('p', {
    staticClass: "tx8",
    attrs: {
      "id": "d41157231"
    }
  }, [_vm._v("'Late for what?' I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx8",
    attrs: {
      "id": "d41157251"
    }
  }, [_vm._v("'A meeting, master, a meeting. Now, have you got a tie?'")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41157271"
    }
  }, [_vm._v("His large, brown eyes twinkled hopefully at me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41157291"
    }
  }, [_vm._v("'I've got two,' I said. 'One of them's the Garrick Club, which I don't belong to, and the other one's holding the lavatory cistern to the wall.'")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41157311"
    }
  }, [_vm._v("I sat down at the table and saw that he'd even found a pot of Keiller's Dundee marmalade from somewhere. I never really knew how he did these things, but Solomon could rootle around in a dustbin and pull out a car if he had to. A good man to go into the desert with.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41157341"
    }
  }, [_vm._v("Maybe that was where we were going.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41157361"
    }
  }, [_vm._v("'So, master, what's paying your bills these days?' He parked half his bottom on the table and watched me eat.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41157381"
    }
  }, [_vm._v("'I hoped you were.'")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41157401"
    }
  }, [_vm._v("The marmalade was delicious, and I wanted to make it last, but I could tell Solomon was anxious to be off. He glanced at his watch and disappeared back into the bedroom, where I could hear him rattling his way through the wardrobe, trying to find a jacket.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41157421"
    }
  }, [_vm._v("'Under the bed,' I called. I picked up the dictaphone from the table. The tape was still inside.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41157441"
    }
  }, [_vm._v("As I gulped down the tea, Solomon came in carrying a double-breasted blazer with two buttons missing. He held it out like a valet. I stayed where I was.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41157461"
    }
  }, [_vm._v("'Oh master,' he said. 'Please don't be difficult. Not before the harvest is in, and the mules are rested.'")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41157481"
    }
  }, [_vm._v("'Just tell me where we're going.'")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41157501"
    }
  }, [_vm._v("'Down the road, in a big shiny car. You'll love it. And on the way home you can have an ice-cream.'")]), _vm._v(" "), _c('p', {
    staticClass: "tx8",
    attrs: {
      "id": "d41157521"
    }
  }, [_vm._v("Slowly, I got to my feet and shrugged on the blazer.")]), _vm._v(" "), _c('p', {
    staticClass: "tx8",
    attrs: {
      "id": "d41157541"
    }
  }, [_vm._v("'David,' I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx8",
    attrs: {
      "id": "d41157571"
    }
  }, [_vm._v("'Still here, master.'")]), _vm._v(" "), _c('p', {
    staticClass: "tx8",
    attrs: {
      "id": "d41157591"
    }
  }, [_vm._v("'What's happening?'")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41157611"
    }
  }, [_vm._v("He pursed his lips and frowned slightly. Bad form to ask questions like that. I stood my ground.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41157631"
    }
  }, [_vm._v("'Am I in trouble?' I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41157651"
    }
  }, [_vm._v("He frowned a little more, and then looked up at me with his calm, steady eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "tx8",
    attrs: {
      "id": "d41157671"
    }
  }, [_vm._v("'Seems like it.'")]), _vm._v(" "), _c('p', {
    staticClass: "tx8",
    attrs: {
      "id": "d41157691"
    }
  }, [_vm._v("'Seems like it?'")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41157711"
    }
  }, [_vm._v("'There's a foot of heavy cable in that drawer. The young master's weapon of choice.'")]), _vm._v(" "), _c('p', {
    staticClass: "tx8",
    attrs: {
      "id": "d41157751"
    }
  }, [_vm._v("'So?'")]), _vm._v(" "), _c('p', {
    staticClass: "tx8",
    attrs: {
      "id": "d41157771"
    }
  }, [_vm._v("He gave me a small, polite smile.")]), _vm._v(" "), _c('p', {
    staticClass: "tx8",
    attrs: {
      "id": "d41157791"
    }
  }, [_vm._v("'Trouble for somebody.'")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41157821"
    }
  }, [_vm._v("'Oh come off it, David,' I said. 'I've had that for months. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41157841"
    }
  }, [_vm._v("Been meaning to wire up two things that are very close to each other.'")]), _vm._v(" "), _c('p', {
    staticClass: "tx8",
    attrs: {
      "id": "d41157861"
    }
  }, [_vm._v("'Yes. Receipt's from two days ago. Still in the bag.'")]), _vm._v(" "), _c('p', {
    staticClass: "tx8",
    attrs: {
      "id": "d41157881"
    }
  }, [_vm._v("We looked at each other for a while.")]), _vm._v(" "), _c('p', {
    staticClass: "tx30",
    attrs: {
      "id": "d41157901"
    }
  }, [_vm._v("'Sorry, master,' he said. 'Black arts. Let's go.'")]), _vm._v(" "), _c('p', {
    staticClass: "tx21",
    attrs: {
      "id": "d41157921"
    }
  }, [_vm._v("The car was a Rover, which meant it was official. Nobody drives these idiotically snobbish cars, with their absurd bundles of wood and leather, badly glued into every seam and crevice of the interior, unless they absolutely have to. And only the government and the board of Rover have to.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41157941"
    }
  }, [_vm._v("I didn't want to interrupt Solomon as he drove, because he had a nervous relationship with cars, and didn't even like it if you switched on the radio. He wore driving gloves, a driving hat, driving glasses and a driving expression, and he fed the wheel through his hands in the way everyone does until four seconds after they've passed their test. But as we trickled past Horseguards Parade, more or less flirting with twenty-five miles an hour, I thought I'd risk it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41157961"
    }
  }, [_vm._v("'Don't suppose there's any chance of me knowing what it is I'm supposed to have done?'")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41157981"
    }
  }, [_vm._v("Solomon sucked his teeth and gripped the wheel even harder, concentrating furiously as we negotiated a particularly awkward stretch of wide, empty road. When he'd checked the speed, the revs, the fuel, the oil pressure, the temperature, the time, and his seatbelt, twice, he decided he could afford an answer.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41158001"
    }
  }, [_vm._v("'What you were supposed to have done,' he said, through clenched teeth, 'is stay good and noble, master. As you  always were.'")]), _vm._v(" "), _c('p', {
    staticClass: "tx8",
    attrs: {
      "id": "d41158021"
    }
  }, [_vm._v("We pulled into a courtyard behind the Ministry of Defence.")]), _vm._v(" "), _c('p', {
    staticClass: "tx8",
    attrs: {
      "id": "d41158051"
    }
  }, [_vm._v("'Haven't I done that?' I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx30",
    attrs: {
      "id": "d41158071"
    }
  }, [_vm._v("'Bingo. Parking space. We've died and gone to heaven.'")]), _vm._v(" "), _c('p', {
    staticClass: "tx21",
    attrs: {
      "id": "d41158091"
    }
  }, [_vm._v("In spite of a large security notice proclaiming that all Ministry of Defence installations were in a state of Bikini Amber alert, the guards at the door let us through with no more than a glance.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41158111"
    }
  }, [_vm._v("British security guards, I've noticed, always do this; unless you happen actually to work in the building they're guarding, in which case they'll check everything from the fillings in your teeth to your trouser turn-ups to see if you're the same person who went out to get a sandwich fifteen minutes ago. But if you're a strange face, they'll let you straight through, because frankly, it would just be too embarrassing to put you to any trouble. ' ")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41158131"
    }
  }, [_vm._v("If you want a place guarded properly, hire Germans.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41158151"
    }
  }, [_vm._v("Solomon and I travelled up three sets of stairs, down half a dozen corridors and in two lifts, with him signing me in at various points along the way, until we reached a dark green door labelled C188. Solomon knocked, and we heard a woman's voice shout 'wait', and then 'okay'.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41158171"
    }
  }, [_vm._v("Inside there was a wall three feet away. And between the wall and the door, in this unbelievably tiny space, a girl in a lemon-coloured shirt sat at a desk, with word processor, potted plant, mug of pencils, furry gonk, and wadges of orange paper. It was incredible that anyone or anything could function in such a space. It was like suddenly discovering a family of otters in one of your shoes.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41158191"
    }
  }, [_vm._v("If you've ever done that.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41158211"
    }
  }, [_vm._v("'He's expecting you,' she said, nervously holding both her arms out across the desk in case we dislodged anything.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41158231"
    }
  }, [_vm._v("'Thank you, madam,' said Solomon, squeezing past the desk.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41158251"
    }
  }, [_vm._v("'Agoraphobic?' I asked, following him, and if there'd been enough room I would have kicked myself, because she must  have heard that fifty times a day.")]), _vm._v(" "), _c('p', {
    staticClass: "tx16",
    attrs: {
      "id": "d41158281"
    }
  }, [_vm._v("Solomon knocked on the inner door and we walked straight through.")]), _vm._v(" "), _c('p', {
    staticClass: "tx21",
    attrs: {
      "id": "d41158301"
    }
  }, [_vm._v("Every square foot the secretary had lost, this office had gained.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41158321"
    }
  }, [_vm._v("Here, we had a high ceiling, windows on two sides hung with government-issue net curtains and, between the windows, a desk about the size of a squash court. Behind the desk, a balding head was bowed in concentration.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41158341"
    }
  }, [_vm._v("Solomon headed for the central rose of the Persian carpet, and I took up a position just off his left shoulder.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41158361"
    }
  }, [_vm._v("'Mr O'Neal?' said Solomon. 'Lang for you.'")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41158381"
    }
  }, [_vm._v("We waited.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41158401"
    }
  }, [_vm._v("O'Neal, if that really was his name, which I doubted, looked like all men who sit behind large desks. People say that dog-owners resemble their dogs, but I've always thought the same is true, if not truer, of desk-owners and their desks. It was a large, flat face, with large, flat ears, and plenty of useful places for keeping paper-clips. Even his lack of any beard growth corresponded with the dazzling French polish. He was in expensive shirt sleeves, and I couldn't see a jacket anywhere.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41158461"
    }
  }, [_vm._v("'I thought we said nine-thirty,' said O'Neal without looking up or at his watch.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41158481"
    }
  }, [_vm._v("This voice was not believable at all. It strained for a patrician languor, and missed it by a mile. It was tight and reedy, and in other circumstances I might have felt sorry for Mr O'Neal. If that really was his name. Which I doubted.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41158511"
    }
  }, [_vm._v("'Traffic, I'm afraid,' said Solomon. 'Got here as fast as we could.'")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41158531"
    }
  }, [_vm._v("Solomon looked out of the window, as if to say he'd done his bit. O'Neal stared at him, glanced at me, and then went back to his performance of Reading Something Important.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41158551"
    }
  }, [_vm._v("Now that Solomon had delivered me safely, and there was no chance of getting him into any trouble, I decided it was time to assert myself a little.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41158571"
    }
  }, [_vm._v("'Good morning, Mr O'Neal,' I said, in a stupidly loud voice. The sound bounced back from the distant walls. 'Sorry to see this isn't a convenient time. It's not that good for me either. Why don't I have my secretary make another appointment with your secretary? In fact, why don't our secretaries have lunch together? Really put the world to rights.'")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41158591"
    }
  }, [_vm._v("O'Neal ground his teeth together for a moment, and then looked up at me with what he obviously thought was a penetrating stare.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41158611"
    }
  }, [_vm._v("When he'd overdone that, he put down the papers and rested his hands on the edge of the desk. Then he took them off the desk and put them on his lap. Then he got annoyed with me for having seen him carry out this awkward procedure.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41158631"
    }
  }, [_vm._v("'Mr Lang,' he said. 'You realise where you are?' He pursed his lips in a practised fashion.")]), _vm._v(" "), _c('p', {
    staticClass: "tx8",
    attrs: {
      "id": "d41158651"
    }
  }, [_vm._v("'Indeed I do, Mr O'Neal. I am in room C188.'")]), _vm._v(" "), _c('p', {
    staticClass: "tx8",
    attrs: {
      "id": "d41158671"
    }
  }, [_vm._v("'You are in the Ministry of Defence.'")]), _vm._v(" "), _c('p', {
    staticClass: "tx8",
    attrs: {
      "id": "d41158691"
    }
  }, [_vm._v("'Mmm. Jolly nice too. Any chairs about?'")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41158711"
    }
  }, [_vm._v("He glared at me again, and then flicked his head at Solomon, who went over to the door and dragged a reproduction Regency thing to the middle of the carpet. I stayed where I was.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41158741"
    }
  }, [_vm._v("'Do sit down, Mr Lang.'")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41158761"
    }
  }, [_vm._v("'Thanks, I'd rather stand,' I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41158781"
    }
  }, [_vm._v("Now he was genuinely thrown. We used to do this kind of thing to a geography teacher at school. He'd left after two terms to become a priest in the Western Isles.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41158801"
    }
  }, [_vm._v("'What do you know, please, about Alexander Woolf?' O'Neal leant forward with his forearms on the desk, and I caught a glimpse of a very gold watch. Much too gold to be gold.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41158841"
    }
  }, [_vm._v("'Which one?'")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41158861"
    }
  }, [_vm._v("He frowned.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41158881"
    }
  }, [_vm._v("'What do you mean, \"which one?\" How many Alexander Woolfs do you know?'")]), _vm._v(" "), _c('p', {
    staticClass: "tx8",
    attrs: {
      "id": "d41158901"
    }
  }, [_vm._v("I moved my lips slightly, counting to myself.")]), _vm._v(" "), _c('p', {
    staticClass: "tx8",
    attrs: {
      "id": "d41158921"
    }
  }, [_vm._v("'Five.'")]), _vm._v(" "), _c('p', {
    staticClass: "tx8",
    attrs: {
      "id": "d41158941"
    }
  }, [_vm._v("He sighed irritably. Come along, 4B, settle down.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41158971"
    }
  }, [_vm._v("'The Alexander Woolf to whom I am referring,' he said, with that particular tone of sarcastic pedantry that every Englishman behind a desk slides into sooner or later, 'has a house in Lyall Street, Belgravia.'")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41158991"
    }
  }, [_vm._v("'Lyall Street. Of course.' I tutted to myself. 'Six, then.'")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41159011"
    }
  }, [_vm._v("O'Neal shot a look at Solomon, but didn't get any help there. He turned back to me, with a creepy smile.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41159031"
    }
  }, [_vm._v("'I'm asking you, Mr Lang, what do you know about him?'")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41159051"
    }
  }, [_vm._v("'He has a house in Lyall Street, Belgravia,' I said. 'Is that any help?'")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41159071"
    }
  }, [_vm._v("This time, O'Neal tried another tack. He took a deep breath and exhaled slowly, which was meant to make me think that beneath that chubby frame there lurked an oiled killing machine, and for two pins he'd be over that desk and beating the life out of me. It was a pathetic performance. He reached into a drawer and pulled out a buff folder, then started angrily flicking through its contents.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41159091"
    }
  }, [_vm._v("'Where were you at ten-thirty last night?'")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41159111"
    }
  }, [_vm._v("'Windsurfing off the Ivory Coast,' I said, almost before he'd finished speaking.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41159131"
    }
  }, [_vm._v("'I'm asking you a serious question, Mr Lang,' said O'Neal. 'I advise you, most strongly, to give me a serious answer.'")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41159171"
    }
  }, [_vm._v("'And I'm telling you it's none of your business.'")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41159201"
    }
  }, [_vm._v("'My business ...' he began.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41159221"
    }
  }, [_vm._v("'Your business is defence.' I was suddenly shouting, genuinely shouting, and out of the corner of my eye I could see that Solomon had turned to watch. 'And the thing you're being paid to defend is my right to do whatever I want without having to answer a lot of fucking questions.' I dropped back into a normal gear. 'Anything else?'")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41159241"
    }
  }, [_vm._v("He didn't answer, so I turned and walked towards the door.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41159261"
    }
  }, [_vm._v("'Cheerio, David,' I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41159281"
    }
  }, [_vm._v("Solomon didn't answer either. I had my hand on the doorknob when O'Neal spoke.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41159301"
    }
  }, [_vm._v("'Lang, I want you to know that I could have you arrested the second you leave this building.'")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41159321"
    }
  }, [_vm._v("I turned and looked at him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41159341"
    }
  }, [_vm._v("'For what?'")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41159361"
    }
  }, [_vm._v("I suddenly didn't like this. I didn't like this because, for the first time since I came in, O'Neal looked relaxed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx8",
    attrs: {
      "id": "d41159381"
    }
  }, [_vm._v("'Conspiracy to murder.'")]), _vm._v(" "), _c('p', {
    staticClass: "tx8",
    attrs: {
      "id": "d41159401"
    }
  }, [_vm._v("The room was very quiet.")]), _vm._v(" "), _c('p', {
    staticClass: "tx30",
    attrs: {
      "id": "d41159431"
    }
  }, [_vm._v("'Conspiracy?' I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx21",
    attrs: {
      "id": "d41159451"
    }
  }, [_vm._v("You know how it is when you're caught up in the flow of things. Normally, words are sent from the brain towards the mouth, and somewhere along the line you take a moment to check them, see that they are actually the ones you ordered and that they're nicely wrapped, before you bundle them on their way towards your palate and out into the fresh air.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41159471"
    }
  }, [_vm._v("But when you're caught up in the flow of things, the checking part of your mind can fall down on the job.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41159491"
    }
  }, [_vm._v("O'Neal had uttered three words: 'Conspiracy to murder'.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41159511"
    }
  }, [_vm._v("The correct word for me to repeat in an incredulous tone of voice would have been 'murder'; a very small, and psychiatrically disturbed, section of the population might have opted for the 'to'; but the one word out of the three I most definitely should not have chosen to repeat was 'conspiracy'.")]), _vm._v(" "), _c('p', {
    staticClass: "tx16",
    attrs: {
      "id": "d41159531"
    }
  }, [_vm._v("Of course, if we'd had the conversation again, I'd have done things very differently. But we didn't.")]), _vm._v(" "), _c('p', {
    staticClass: "tx21",
    attrs: {
      "id": "d41159551"
    }
  }, [_vm._v("Solomon was looking at me, and O'Neal was looking at Solomon. I busied myself with a verbal dustpan and brush.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41159571"
    }
  }, [_vm._v("'What the hell are you talking about? Have you really got nothing better to do? If you're talking about that business last night, then you should know, if you've read my statement, that I'd never seen that man before in my life, that I was defending myself against an illegal assault, and that in the course of the struggle he ... hit his head.'")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41159621"
    }
  }, [_vm._v("I was suddenly conscious of how limp a phrase that is.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41159641"
    }
  }, [_vm._v("The police,' I continued, 'declared themselves fully satisfied, and ...'")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41159661"
    }
  }, [_vm._v("I stopped.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41159691"
    }
  }, [_vm._v("O'Neal had leaned back in his chair and put both hands behind his head. A patch of sweat the size of a ten pence piece showed at each armpit.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41159711"
    }
  }, [_vm._v("'Well, of course, they "), _c('i', [_vm._v("would ")]), _vm._v("declare themselves satisfied, wouldn't they?' he said, looking horribly confident. He waited for me to say something, but nothing came to mind so I let him go on. 'Because they didn't know then what we know now.'\n         ")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41159761"
    }
  }, [_vm._v("I sighed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41159781"
    }
  }, [_vm._v("'Oh God, I am just so fascinated by this conversation I think I might have a nosebleed. What do you know now that is so fucking important that I have to be dragged here at this frankly ridiculous time of day?'")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41159801"
    }
  }, [_vm._v("'Dragged?' he said, eyebrows shooting towards his hairline. He turned to Solomon. 'Did you "), _c('i', [_vm._v("drag ")]), _vm._v("Mr Lang here?'\n         ")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41159851"
    }
  }, [_vm._v("O'Neal had suddenly gone camp and playful, and it was a nauseating sight. Solomon must have been as appalled by it as I was, because he didn't answer.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41159871"
    }
  }, [_vm._v("'My life is ebbing away in this room,' I said, irritably. 'Please get to the point.'")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41159911"
    }
  }, [_vm._v("'Very well,' said O'Neal. 'We know now, but the police didn't know then, that a week ago you had an assignation with a Canadian arms dealer by the name of McCluskey. McCluskey offered you a hundred thousand dollars if you would... terminate Woolf. We know now that you turned up at Woolf's London house and that you were confronted by a man named Rayner - aka Wyatt, aka Miller - legitimately employed by Woolf in the capacity of bodyguard. We know that Rayner was severely injured as a result of this confrontation.'")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d41159951"
    }
  }, [_vm._v("My stomach seemed to have contracted to the size and density of a cricket ball. A drop of sweat abseiled amateurishly down my back.")]), _vm._v(" "), _c('p', {
    staticClass: "tx33",
    attrs: {
      "id": "d41159981"
    }
  }, [_vm._v("O'Neal went on. 'We know that in spite of your story to  the police, not one but two 999 calls were made to the operator last night; the first one being for an ambulance only, the second for the police. The calls were made fifteen minutes apart. We know that you gave a false name to the police, for reasons we have not yet established. And finally,' he looked up at me like a bad magician with a rabbit-filled hat, 'we know that the sum of twenty-nine thousand, four hundred pounds, equivalent to fifty thousand US dollars, was transferred to your bank account at Swiss Cottage four days ago.' He snapped the file shut and smiled. 'How's that for starters?'")]), _vm._v(" "), _c('p', {
    staticClass: "tx34",
    attrs: {
      "id": "d411510001"
    }
  }, [_vm._v("I was sitting on the chair in the middle of O'Neal's office. Solomon had gone to make some coffee for me and camomile tea for himself, and the world was slowing down slightly.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d411510041"
    }
  }, [_vm._v("'Look,' I said, 'it's perfectly obvious that for some reason I'm being set up.'")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d411510061"
    }
  }, [_vm._v("'Explain to me please, Mr Lang,' said O'Neal, 'why that conclusion is obvious.'")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d411510081"
    }
  }, [_vm._v("He'd gone camp again. I took a deep breath.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d411510101"
    }
  }, [_vm._v("'Well, I'm telling you first of all that I don't know anything about that money. Anyone could have done that, from any bank in the world. That's easy.'")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d411510121"
    }
  }, [_vm._v("O'Neal made a big show of removing the top of his Parker Duofold and jotting something down on a pad of paper.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d411510141"
    }
  }, [_vm._v("'And then there's the daughter,' I said. 'She saw the fight. She vouched for me to the police last night. Why haven't you got her in here?'")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d411510181"
    }
  }, [_vm._v("The door opened and Solomon backed in, balancing three cups. He'd got rid of his brown raincoat somewhere, and was now sporting a zip-up cardigan of the same colour. O'Neal was obviously annoyed by it, and even I could see that it didn't live up to the rest of the room.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d411510211"
    }
  }, [_vm._v("'We do, I assure you, intend to interview Miss Woolf at some convenient juncture,' said O'Neal, as he sipped gingerly at his coffee. 'However, the immediate concern of this department's operation is you. You, Mr Lang, were asked to  perform an assassination. With or without your consent, money was transferred to your bank account. You present yourself at the target's house and very nearly kill his bodyguard. You then...'")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d411510231"
    }
  }, [_vm._v("'Wait a minute,' I said. 'Just wait one cotton-fucking minute here. What's all this bodyguard stuff? Woolf wasn't even there.'")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d411510251"
    }
  }, [_vm._v("O'Neal gazed back at me in a nastily unruffled way.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d411510271"
    }
  }, [_vm._v("'I mean how,' I went on, 'does a bodyguard guard a body who isn't in the same building? By phone? This is digital bodyguarding, is it?'")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d411510291"
    }
  }, [_vm._v("'You searched the house, did you, Lang?' said O'Neal. 'You went to the house, and searched it for Alexander Woolf?' A smile played clumsily about his lips.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d411510331"
    }
  }, [_vm._v("'She told me he wasn't there,' I said, annoyed at his pleasure. 'And anyway, fuck off.'")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d411510351"
    }
  }, [_vm._v("He flinched slightly.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d411510371"
    }
  }, [_vm._v("'Nevertheless,' he said eventually, 'under the circumstances, your presence in the house makes you worthy of our valuable time and effort.'")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d411510391"
    }
  }, [_vm._v("I still couldn't work this out.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d411510411"
    }
  }, [_vm._v("'Why?' I said. 'Why you and not the police? What's so special about Woolf?' I looked from O'Neal to Solomon. 'If it comes to that, what's so special about me?'")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d411510441"
    }
  }, [_vm._v("The phone on O'Neal's desk chirped, and he snatched it up with a practised flourish, flicking the wire behind his elbow as he brought the receiver to his ear. He looked at me as he talked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d411510461"
    }
  }, [_vm._v("'Yes? Yes Indeed. Thank you.'")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d411510481"
    }
  }, [_vm._v("The receiver was back in its cradle and fast asleep in an instant. Watching him handle it, I could tell that the telephone was O'Neal's one great skill.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d411510501"
    }
  }, [_vm._v("He scribbled something on his pad and beckoned Solomon over to the desk. Solomon peered at it, and then they both looked at me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d411510521"
    }
  }, [_vm._v("'Do you own a firearm, Mr Lang?'")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d411510541"
    }
  }, [_vm._v("O'Neal asked this with a cheerful, efficient smile. Would  you prefer an aisle or a window seat?")]), _vm._v(" "), _c('p', {
    staticClass: "tx8",
    attrs: {
      "id": "d411510561"
    }
  }, [_vm._v("I started to feel sick.")]), _vm._v(" "), _c('p', {
    staticClass: "tx8",
    attrs: {
      "id": "d411510581"
    }
  }, [_vm._v("'No, I do not.'")]), _vm._v(" "), _c('p', {
    staticClass: "tx8",
    attrs: {
      "id": "d411510601"
    }
  }, [_vm._v("'Had access to firearms of any sort?'")]), _vm._v(" "), _c('p', {
    staticClass: "tx8",
    attrs: {
      "id": "d411510621"
    }
  }, [_vm._v("'Not since the army.'")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d411510641"
    }
  }, [_vm._v("'I see,' said O'Neal, nodding to himself. He left a long pause, checking the pad to see that he'd got the details absolutely right. 'So the news that a nine millimetre Browning pistol, with fifteen rounds of ammunition, has been found in your flat would come as a surprise to you?'")]), _vm._v(" "), _c('p', {
    staticClass: "tx8",
    attrs: {
      "id": "d411510671"
    }
  }, [_vm._v("I thought about this.")]), _vm._v(" "), _c('p', {
    staticClass: "tx8",
    attrs: {
      "id": "d411510691"
    }
  }, [_vm._v("'It's more of a surprise that my flat is being searched.'")]), _vm._v(" "), _c('p', {
    staticClass: "tx8",
    attrs: {
      "id": "d411510711"
    }
  }, [_vm._v("'Never mind that.'")]), _vm._v(" "), _c('p', {
    staticClass: "tx8",
    attrs: {
      "id": "d411510731"
    }
  }, [_vm._v("I sighed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx8",
    attrs: {
      "id": "d411510751"
    }
  }, [_vm._v("'All right then,' I said. 'No, I'm not particularly surprised.'")]), _vm._v(" "), _c('p', {
    staticClass: "tx8",
    attrs: {
      "id": "d411510771"
    }
  }, [_vm._v("'What do you mean?'")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d411510791"
    }
  }, [_vm._v("'I mean that I'm starting to get the hang of how today is going.' O'Neal and Solomon looked blank. 'Oh do come on,' I said. 'Anyone who's prepared to spend thirty thousand pounds to make me look like a hired gun presumably wouldn't stop at another three hundred to make me look like a hired gun who has a gun he can hire.'")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d411510811"
    }
  }, [_vm._v("O'Neal played with his bottom lip for a moment, squeezing it on either side between thumb and forefinger.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d411510831"
    }
  }, [_vm._v("'I have a problem here, don't I, Mr Lang?'")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d411510851"
    }
  }, [_vm._v("'Do you?'")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d411510871"
    }
  }, [_vm._v("'Yes, I rather think I do,' he said. He let go of the lip, and it hung there in a bulbous pout, as if it didn't want to go back to its original shape. 'Either you are an assassin, or someone is trying to make you look like one. The problem is that every piece of evidence I have applies equally well to both possibilities. It really is very difficult.'")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d411510901"
    }
  }, [_vm._v("I shrugged.")]), _vm._v(" "), _c('p', {
    staticClass: "tx16",
    attrs: {
      "id": "d411510921"
    }
  }, [_vm._v("'That must be why they gave you such a big desk,' I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx21",
    attrs: {
      "id": "d411510941"
    }
  }, [_vm._v("Eventually they had to let me go. For whatever reason, they didn't want to involve the police with an illegal firearm  charge, and the Ministry of Defence is not, so far as I know, equipped with its own detention cells.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d411510961"
    }
  }, [_vm._v("O'Neal asked me for my passport, and before I could spin a yarn about having lost it in the tumble-dryer, Solomon produced it from his hip-pocket. I was told to remain contactable, and to let them know if I received any further approaches from strange men. There wasn't much I could do but agree.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d411510981"
    }
  }, [_vm._v("As I left the building and strolled through St James's Park in some rare April sunshine, I tried to work out whether I felt any different, knowing that Rayner had only been trying to do his job. I also wondered why I hadn't known that he was Woolf's bodyguard. Or even that he had one.")]), _vm._v(" "), _c('p', {
    staticClass: "tx10",
    attrs: {
      "id": "d411511001"
    }
  }, [_vm._v("But much, much more to the point, why hadn't Woolf's daughter?")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-181b1b34","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chap11_thegunse_9781569478004_epub_part11.vue
// module id = 87
// module chunks = 0